module.exports = __webpack_public_path__ + "media/images/cbjj/membership/card-ornament-green-primary-c4bbcf032394650eae89e7a41d976250.svg";